import React from 'react';
import PropTypes from 'prop-types';
import './styles/flags.css';
import Flags from './images';

export default function Flag({ currency }) {
  return (
    <span className={'fl flag-sprite flag-sprite-' + currency.toLowerCase()} />
  );
}

Flag.propTypes = {
  currency: PropTypes.string,
};
